import '@firebase/firestore'
import momentlib from 'moment'
import EventBus from '@/EventBus'
export default {
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: [Object, String, Array, Number]
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    }
  },
  data () {
    return {
      value: this.config.hasOwnProperty('value') ? this.config.value : this.modelProps,
      moment: momentlib
    }
  },
  created () {
  },
  model: {
    prop: 'modelProps',
    event: 'not-mutable'
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    formatString (string, item) {
      return eval(string)
    },
    validate () {},
    handlerClick(item) {
      this.$router.push(item)
      EventBus.$emit('reloadPage', null)
    }
  }
}
